import { render, staticRenderFns } from "./SalaPresenciais.vue?vue&type=template&id=bb28b52a&scoped=true"
import script from "./SalaPresenciais.vue?vue&type=script&lang=js"
export * from "./SalaPresenciais.vue?vue&type=script&lang=js"
import style0 from "./SalaPresenciais.vue?vue&type=style&index=0&id=bb28b52a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb28b52a",
  null
  
)

export default component.exports